"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AwsMpAccount = exports.AwsMarketplaceType = void 0;
var AwsMarketplaceType;
(function (AwsMarketplaceType) {
    AwsMarketplaceType["ON_DEMAND"] = "On Demand";
    AwsMarketplaceType["CAPACITY"] = "Capacity";
    AwsMarketplaceType["ON_DEMAND_ADD_SUBSCRIPTION"] = "On Demand Add Subscription";
})(AwsMarketplaceType || (exports.AwsMarketplaceType = AwsMarketplaceType = {}));
var AwsMpAccount;
(function (AwsMpAccount) {
    AwsMpAccount["SFC_INC_MARKETPLACE_US"] = "sfc-inc-marketplace-us";
    AwsMpAccount["SFC_BV_MARKETPLACE_US"] = "sfc-bv-marketplace-us";
    AwsMpAccount["SFC_BV_MARKETPLACE_EMEA"] = "sfc-bv-marketplace-emea";
    AwsMpAccount["SFC_MARKETPLACE_AUSTRALIA"] = "sfc-marketplace-australia";
    AwsMpAccount["SFC_MARKETPLACE_CANADA"] = "sfc-marketplace-canada";
    AwsMpAccount["SFC_MARKETPLACE_UK"] = "sfc-marketplace-uk";
})(AwsMpAccount || (exports.AwsMpAccount = AwsMpAccount = {}));
//# sourceMappingURL=awsMarketplace.js.map